import React, { useState } from 'react';
import axios from 'axios';
import { Plus, X, UserPlus } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function QuickClientForm({ authHeaders, onCreated, onCancel }) {
  const [form, setForm] = useState({
    type: 'particulier', first_name: '', last_name: '', company_name: '',
    phone: '', email: '', address: '', postal_code: '', city: ''
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await axios.post(`${API_URL}/api/crm/clients`, form, { headers: authHeaders });
      onCreated(res.data);
    } catch (err) {
      alert(err.response?.data?.detail || 'Erreur lors de la création du client');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-3" data-testid="quick-client-form">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold text-blue-800 flex items-center gap-2">
          <UserPlus size={16} />
          Créer un nouveau client
        </h4>
        <button type="button" onClick={onCancel} className="text-gray-400 hover:text-gray-600">
          <X size={16} />
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} className="border rounded px-2 py-1.5 text-xs bg-white" data-testid="quick-client-type">
          <option value="particulier">Particulier</option>
          <option value="professionnel">Professionnel</option>
        </select>
        <input required placeholder="Prénom *" value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} className="border rounded px-2 py-1.5 text-xs" data-testid="quick-client-firstname" />
        <input required placeholder="Nom *" value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} className="border rounded px-2 py-1.5 text-xs" data-testid="quick-client-lastname" />
        {form.type === 'professionnel' && (
          <input placeholder="Société" value={form.company_name} onChange={e => setForm({ ...form, company_name: e.target.value })} className="border rounded px-2 py-1.5 text-xs" />
        )}
        <input required placeholder="Téléphone *" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} className="border rounded px-2 py-1.5 text-xs" data-testid="quick-client-phone" />
        <input placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="border rounded px-2 py-1.5 text-xs" data-testid="quick-client-email" />
      </div>
      <div className="grid grid-cols-3 gap-2">
        <input placeholder="Adresse" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} className="border rounded px-2 py-1.5 text-xs" />
        <input placeholder="Code postal" value={form.postal_code} onChange={e => setForm({ ...form, postal_code: e.target.value })} className="border rounded px-2 py-1.5 text-xs" />
        <input placeholder="Ville" value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} className="border rounded px-2 py-1.5 text-xs" />
      </div>
      <div className="flex justify-end gap-2">
        <button type="button" onClick={onCancel} className="px-3 py-1.5 text-xs text-gray-600 hover:bg-gray-100 rounded">Annuler</button>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={saving || !form.first_name || !form.last_name || !form.phone}
          className="px-3 py-1.5 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 flex items-center gap-1"
          data-testid="quick-client-save-btn"
        >
          <Plus size={14} />
          {saving ? 'Création...' : 'Créer et sélectionner'}
        </button>
      </div>
    </div>
  );
}
